import { Component, inject, OnInit } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatLabel, MatOption, MatSelect } from '@angular/material/select';
import moment from 'moment/moment';

@Component({
    selector: 'mobilize-change-due-date-modal',
    imports: [
        MatFormField,
        FormsModule,
        MatLabel,
        MatSelect,
        MatOption,
    ],
    templateUrl: './change-due-date-modal.component.html',
    styleUrl: './change-due-date-modal.component.scss'
})
export class ChangeDueDateModalComponent implements OnInit {

    private dialogRef = inject(MatDialogRef<ChangeDueDateModalComponent>);
    private data = inject(MAT_DIALOG_DATA);

    dueDate: any;
    currentDay: any;

    ngOnInit() {
        this.currentDay = moment(this.data.contract.next_due_date).format('DD');
    }

    close(event: any) {
        const payload: any = {
            dueDate: this.dueDate,
            change: event
        }
        this.dialogRef.close(payload);
    }
}
